import React from 'react';

import type { FacebookStoryComponentsProps } from './types';

export function Body(_props: FacebookStoryComponentsProps): React.JSX.Element {
	return <div>Facebook Story Body</div>;
}
